import PersonIcon from '@mui/icons-material/Person'

import { getUserFullName } from '../../components/UserFullNameField'
import { USER_ACTIONS } from '../../config/users'

export default {
  name: 'users',
  recordRepresentation: getUserFullName,
  icon: PersonIcon,
  options: {
    referenceKey: 'user_id',
    defaultSort: { field: 'last_name', order: 'ASC' },
    defaultFilterValues: { closed: false },
    actions: USER_ACTIONS,
    badge: true,
  },
}
